<template>
    <div>

        <vue-headful title="Employee Import :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/employees`">
                        <i class="fa fa-group"></i> Employees
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Import
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <div class="alert alert-success">
                    File must be a CSV with the first row containing the columns names in this <a href="/employees/import/template" target="_blank">Template</a>
                </div>
                <div v-bind:class="{ 'form-group': true, 'has-error': errors.files }" class="row">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">File</label>
                    <div class="col-sm-8">

                        <b-form-file v-model="file" class="mt-3" plain></b-form-file>

                        <span v-if="errors.files" class="text-danger">
                            <span v-for="error in errors.files">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right"></label>
                    <div class="col-sm-8">
                        <b-form-checkbox v-model="markEmployeesInactive" :value="1" :unchecked-value="0" plain> Mark Employees Inactive who are not on the import?</b-form-checkbox>
                    </div>
                </div>

                <div class="form-group row" v-if="markEmployeesInactive">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right"></label>
                    <div class="col-sm-8">
                        <b-form-checkbox v-model="include_sub_employees" :value="1" :unchecked-value="0" plain> Include Subcontractor Employees? If checked, subcontractor employees who are not on your import file will be marked inactive.</b-form-checkbox>
                    </div>
                </div>
                <div class="form-group row" v-if="markEmployeesInactive">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right"></label>
                    <div class="col-sm-8">
                        <b-form-checkbox v-model="include_temp_employees" :value="1" :unchecked-value="0" plain> Include Temp Employees? If checked, temp employees who are not on your import file will be marked inactive.</b-form-checkbox>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-success" @click="importFile" :disabled="saving">
                    Import File <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                saving: false,
                file: [],
                errors: {},
                markEmployeesInactive: 0,
                include_sub_employees: 0,
                include_temp_employees: 0,
            }
        },

        methods: {
            importFile() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setup payload
                var payload = {
                    markEmployeesInactive: this.markEmployeesInactive,
                    include_sub_employees: this.include_sub_employees,
                    include_temp_employees: this.include_temp_employees,
                };

                //Send it
                this.$http
                .postWithFiles('employees/import', payload, [this.file])
                .then(response => {
                    this.$toastr.success('Employee Import in Progress. You will receive an email when it is complete.');

                    //Return to main list?
                    this.$router.push('/employees');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },
    }
</script>
